import { render, staticRenderFns } from "./global-dialog.vue?vue&type=template&id=58054a62&scoped=true"
import script from "./global-dialog.vue?vue&type=script&lang=js"
export * from "./global-dialog.vue?vue&type=script&lang=js"
import style0 from "./global-dialog.vue?vue&type=style&index=0&id=58054a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58054a62",
  null
  
)

export default component.exports